import { chartBody } from "./chartBody.model";
import { chartHeader } from "./chartHeader";

export class LastTermDistribution {

    data:chartBody[];
    header:chartHeader[];

    constructor() {
        this.data = [];
        this.header = [];
    }

}